import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui";


export default class Section {
  constructor(dom) {
    window.addEventListener("resize", () => this.resize());
    this.dom = dom
  }

  init() {
    const type = this.dom.dataset.type

    switch (type) {
      case '_bg_image_with_heading':
        this.handle_bg_image_with_heading()
        break;
      case '_left_content_right_image':
        this.handle_left_content_right_image()
        break;
      case '_slider_left_content_right_image':
        this.handle_slider_left_content_right_image()
        break;
      case '_left_title_image_right_special_texts':
        this.handle_left_title_image_right_special_texts()
        break;
      default:
        break;
    }
  }

  handle_bg_image_with_heading() {
    gsap.to(this.dom.querySelector('.bg'), {
      scale: 1,
      scrollTrigger: {
        trigger: this.dom,
        start: () => {
          // return `top ${document.body.style.getPropertyValue("--header-height")}`
          return `bottom 0`
        },
        end: () => {
          // return `+=100%`
          return `+=${window.innerHeight - document.body.style.getPropertyValue("--header-height").replace('px', '')}`
        },
        scrub: true,
      }
    })
  }

  handle_left_content_right_image() {
    const el_header = document.querySelector('header')
    const _this = this

    ScrollTrigger.matchMedia({
      // large
      "(min-width: 768px)": function () {
        
        gsap.set(_this.dom.querySelector('.content2'), {
          y: 20,
          opacity: 0,
        });
        ScrollTrigger.create({
          trigger: _this.dom.querySelector('.section-main'),
          start: () => `25% ${el_header.offsetHeight}`,
          end: "+=50%",
          scrub: true,
          // markers: true,
          onUpdate: (self) => {
            const progress = self.progress; // Get the scroll progress (0 to 1)
            gsap.set(_this.dom.querySelector('.content2'), {
              y: gsap.utils.interpolate(20, 0, progress), // Interpolate y from 20 to 0
              opacity: gsap.utils.interpolate(0, 1, progress), // Interpolate opacity from 0 to 1
            });
          },
        });

        gsap.set(_this.dom.querySelector('.content'), {
          x: 0,
        });
        ScrollTrigger.create({
          trigger: _this.dom.querySelector('.section-main'),
          start: () => `top ${el_header.offsetHeight}`,
          end: "+=100%",
          scrub: true,
          // markers: true,
          onUpdate: (self) => {
            const progress = self.progress; // Get the scroll progress (0 to 1)
            gsap.set(_this.dom.querySelector('.content'), {
              x: gsap.utils.interpolate(0, -_this.dom.querySelector('.section-main').offsetWidth / 2, progress), // Interpolate x
            });
          },
        });

        gsap.set(_this.dom.querySelector('.bg'), {
          x: _this.dom.querySelector('.section-main').offsetWidth / 2,
        });
        ScrollTrigger.create({
          trigger: _this.dom,
          pin: _this.dom.querySelector('.section-main'),
          start: () => `top ${el_header.offsetHeight}`,
          end: "+=100%",
          scrub: true,
          // markers: true,
          onUpdate: (self) => {
            const progress = self.progress; // Get the scroll progress (0 to 1)
            gsap.set(_this.dom.querySelector('.bg'), {
              x: gsap.utils.interpolate(_this.dom.querySelector('.section-main').offsetWidth / 2, 0, progress), // Interpolate x
            });
          },
          onRefreshInit: (self) => {
            // set this.dom height to the height of pin-spacer
            const pinSpacer = _this.dom.querySelector('.pin-spacer');
            if (pinSpacer) {
              _this.dom.style.height = `${pinSpacer.offsetHeight}px`;
            }
          }
        });
      },
    
      // small
      "(max-width: 767px)": function () {
        _this.dom.style.height = `auto`;
        gsap.set(_this.dom.querySelector('.content'), {
          x: 0,
        });
        gsap.set(_this.dom.querySelector('.content2'), {
          y: 0,
          opacity: 1,
        });
        gsap.set(_this.dom.querySelector('.bg'), {
          x: 0,
        });
      },
    
      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });

  }

  handle_slider_left_content_right_image() {
    const el_header = document.querySelector('header')
    const slider = this.dom.querySelectorAll('.sliders .slide')
    const sliderContainer = this.dom.querySelector('.sliders');

    // let slider_length = slider[slider.length - 1].offsetLeft - slider[0].offsetLeft

    slider.forEach(item => {
      
      let counter_content = item.querySelector('.counter_content')
      if (counter_content) {
        const counters = item.querySelectorAll(".count");

        ScrollTrigger.create({
          trigger: this.dom.querySelector('.section-main'),
          start: () => {
            // let h = item.offsetLeft - slider[0].offsetLeft
            let h = item.offsetLeft - item.offsetWidth + (window.innerWidth * .15)
            // h = h * 0.75
            return `${h} bottom`
          },
          end: () => {
            return `+=1`
          },
          scrub: true,
          // markers: true,
          onEnter: () => {
            console.log('onEnter');
            counters.forEach(counter => {
              if (parseInt(counter.dataset.count) == 0) {
                return
              }
              let data = { value: 0 } 
              gsap.to(data, {
                value: parseInt(counter.dataset.count),
                snap: { value: 1 },
                duration: 1,
                onUpdate: () => {
                  counter.innerText = data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
              })
            })
          },
          onLeaveBack: () => {
            console.log('onLeaveBack');
            counters.forEach(counter => {
              if (parseInt(counter.dataset.count) == 0) {
                return
              }
              let data = { value: parseInt(counter.dataset.count) } 
              gsap.to(data, {
                value: 0,
                snap: { value: 1 },
                duration: 1,
                onUpdate: () => {
                  counter.innerText = data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
              })
            })
          }
        })
        
      }
    })


    // Create the GSAP animation
    // const sliderAnimation = gsap.to(sliderContainer, {
    //     x: calculateX,
    //     scrollTrigger: {
    //         trigger: this.dom,
    //         pin: this.dom.querySelector('.section-main'),
    //         start: () => `top ${el_header.offsetHeight}`,
    //         end: () => {
    //             // let slider_length = slider[slider.length - 1].offsetLeft - slider[0].offsetLeft;
    //             let slider_length = sliderContainer.offsetWidth * (slider.length - 1);
    //             slider_length = slider_length * 0.75;
    //             return `+=${slider_length}`;
    //         },
    //         scrub: true,
    //     },
    // });

    ScrollTrigger.create({
      trigger: this.dom.querySelector('.scroll-trigger'),
      pin: this.dom.querySelector('.section-main'),
      start: () => {
        
        return `top ${el_header.offsetHeight}`
      },
      end: () => {
          // let slider_length = slider[slider.length - 1].offsetLeft - slider[0].offsetLeft;
          let slider_length = sliderContainer.offsetWidth * (slider.length - 1);
          slider_length = slider_length * 0.75;
          return `+=${slider_length}`;
      },
      onUpdate: (self) => {
        const progress = self.progress.toFixed(3);
        let slider_length = sliderContainer.offsetWidth * (slider.length - 1);
        slider_length = slider_length * -1
        const x = gsap.utils.interpolate(0, slider_length, progress);
        gsap.set(sliderContainer, { x: x });
      },
      scrub: true,
    })

    // Refresh ScrollTrigger and recalculate x on window resize
    // window.addEventListener('resize', () => {
    //     sliderAnimation.vars.x = calculateX(); // Update the x value
    //     sliderAnimation.invalidate().restart(); // Refresh the animation
    //     ScrollTrigger.refresh(); // Refresh ScrollTrigger
    // });
  }

  handle_left_title_image_right_special_texts() {

    const _this = this

    ScrollTrigger.matchMedia({
      // large
      "(min-width: 768px)": function () {
        gsap.fromTo(_this.dom.querySelectorAll('.right .texts span, .right .link'), {
          y: 20,
          opacity: 0,
        }, {
          y: 0,
          opacity: 1,
          // duration: 2.5,
          ease: "power3.out",
          stagger: .7,
          scrollTrigger: {
            trigger: _this.dom.querySelector('.section-main'),
            start: "top 35%",
            end: "+=30%",
            scrub: true,
            // markers: true,
          }
        })
      },
    
      // small
      "(max-width: 767px)": function () {
        gsap.fromTo(_this.dom.querySelectorAll('.right .texts span, .right .link'), {
          y: 20,
          opacity: 0,
        }, {
          y: 0,
          opacity: 1,
          // duration: 2.5,
          ease: "power3.out",
          stagger: .7,
          scrollTrigger: {
            trigger: _this.dom.querySelector('.section-main'),
            start: "top 80%",
            end: "+=30%",
            scrub: true,
            // markers: true,
          }
        })
      },
    
      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
    
  }

  handleProgrammeTrailers() {
    Fancybox.bind(this.dom, "[data-fancybox]", {
      // Your custom options
    });
  }

  initResponsiveHelper() {

  }

  resize() {
  }

}
